import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import BrandLogo from "../components/BrandLogo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

const AccountantPartnerRegisterPage = () => {
  const navigate = useNavigate();
  const { registerAccountant } = useAuth();
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    company_name: "",
    phone: "",
    crc: "",
    notes: "",
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await registerAccountant({
        name: form.name,
        email: form.email,
        password: form.password,
        profile: {
          company_name: form.company_name,
          phone: form.phone,
          crc: form.crc,
          notes: form.notes,
        },
      });
      toast.success("Cadastro de contador parceiro realizado com sucesso!");
      navigate("/accountant");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao cadastrar contador parceiro");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="w-full max-w-2xl">
        <Link to="/" className="inline-flex items-center text-slate-600 hover:text-navy mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Voltar ao início
        </Link>

        <Card className="border-0 shadow-xl">
          <CardHeader className="text-center">
            <BrandLogo size="lg" className="mx-auto mb-4" />
            <CardTitle className="font-serif text-3xl text-navy">Cadastro de Contador Parceiro</CardTitle>
            <CardDescription>
              Tenha um dashboard próprio para acompanhar links, diagnósticos e os benefícios da parceria.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid gap-4 md:grid-cols-2">
                <div>
                  <Label>Nome completo</Label>
                  <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
                </div>
                <div>
                  <Label>E-mail</Label>
                  <Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
                </div>
              </div>

              <div className="grid gap-4 md:grid-cols-2">
                <div>
                  <Label>Senha</Label>
                  <Input type="password" minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required />
                </div>
                <div>
                  <Label>Escritório / empresa</Label>
                  <Input value={form.company_name} onChange={(e) => setForm({ ...form, company_name: e.target.value })} />
                </div>
              </div>

              <div className="grid gap-4 md:grid-cols-2">
                <div>
                  <Label>Telefone</Label>
                  <Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
                </div>
                <div>
                  <Label>CRC</Label>
                  <Input value={form.crc} onChange={(e) => setForm({ ...form, crc: e.target.value })} />
                </div>
              </div>

              <div>
                <Label>Observações</Label>
                <Textarea value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} placeholder="Informações complementares sobre a parceria" />
              </div>

              <Button type="submit" className="w-full bg-navy hover:bg-navy/90" disabled={loading}>
                {loading ? "Cadastrando..." : "Criar acesso de contador parceiro"}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AccountantPartnerRegisterPage;
